import React, { useEffect } from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { AuthoritySection } from './components/AuthoritySection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, initGA4 } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    initGA4();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProofSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <AgitationSection data-id="element-5" />
      <RevelationSection data-id="element-6" />
      <AuthoritySection data-id="element-7" />
      <OfferSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}